import axios from "axios";

class API {
  private baseURL: string;
  private apiEndpoint: any;

  constructor(apiEndpoint: any) {
    this.baseURL = `https://cen.sygengroup.com/api`;
    this.apiEndpoint = apiEndpoint;
  }

  async fetchData(
    id: string | null,
    setState: any,
    filter: string | null = null
  ) {
    try {
      let url = `${this.baseURL}/${this.apiEndpoint}/${id ? id : ""}`;
      const response = await axios.get(url);

      // If response.data.data exists, use it; otherwise, fallback to response.data
      const result = response.data.data ?? response.data;

      if (!id && filter?.toLowerCase() === "freemium") {
        setState(
          Array.isArray(result)
            ? result.filter(
                (item: any) => item.premium === false || item.premium === null
              )
            : []
        );
        return "success";
      } else {
        setState(result);
        return "success";
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      throw error;
    }
  }

  async fetchReviews(id: string | null, setState: any, type: string) {
    try {
      let url = `${this.baseURL}/${this.apiEndpoint}/${type}/${id ? id : ""}`;
      const response = await axios.get(url);
      setState(response.data);
      return "success";
    } catch (error) {
      console.error("Failed to fetch data:", error);
      throw error;
    }
  }

  async createData(data: any) {
    try {
      let url = `${this.baseURL}/${this.apiEndpoint}`;
      const response = await axios.post(url, data);
      return response.data;
    } catch (error) {
      console.error("Failed to create data:", error);
      throw error;
    }
  }

  async updateData(id: any, updatedData: any, setObject: any) {
    try {
      let url = `${this.baseURL}/${this.apiEndpoint}/${id}`;

      const response = await axios.put(url, updatedData);
      setObject((prevData: any) => {
        let updatedData = { ...prevData }; // Start with a copy of prevData

        for (const key in response.data) {
          if (
            response.data.hasOwnProperty(key) &&
            response.data[key] !== prevData[key]
          ) {
            updatedData[key] = response.data[key]; // Update only if the value has changed
          }
        }

        return updatedData;
      });
      return response.data;
    } catch (error) {
      console.error("Failed to update data:", error);
      throw error;
    }
  }

  async deleteData(id: any, type: string | null = null, setObject: any) {
    try {
      let url = `${this.baseURL}/${this.apiEndpoint}/${id}`;
      await axios.delete(url);
      if (type !== "reviews") {
        await this.fetchData(null, setObject);
      }
      return "success";
    } catch (error) {
      console.error("Failed to delete data:", error);
      throw error;
    }
  }

  async login(setAuth: any, payload: any) {
    try {
      let url = `${this.baseURL}/login`;
      const response = await axios.post(url, payload);

      let isOrg = !response.data.details.role;
      setAuth({
        isAuthenticated: true,
        token: response.data.token,
        user: response.data.details,
        isAdmin: isOrg ? false : response.data.details["role"] === "admin",
        isOrg: isOrg,
      });

      return "success";
    } catch (error) {
      console.error("Failed to  login:", error);
      throw error;
    }
  }

  async signup(setAuth: any, payload: any, type: string) {
    try {
      let endpoint = type === "org" ? "org-signup" : "signup";
      let url = `${this.baseURL}/${endpoint}`;
      const response = await axios.post(url, payload);

      /*
            type === "org" ?
                setAuth({
                    isAuthenticated: true,
                    token: response.data.token,
                    user: response.data.org,
                    isAdmin: false,
                    isOrg: true
                })
                :
                setAuth({
                    isAuthenticated: true,
                    token: response.data.token,
                    user: response.data.user,
                    isAdmin: response.data.user["role"] === 'admin',
                    isOrg: false
                })

             */

      return response.data;
    } catch (error: any) {
      console.error("Failed to  sign up:", error);
      throw error.message;
    }
  }

  async addUser(payload: any, setObject: any) {
    try {
      let endpoint = "signup";
      let url = `${this.baseURL}/${endpoint}`;
      const response = await axios.post(url, payload);
      await this.fetchData(null, setObject);
      return response.data;
    } catch (error: any) {
      console.error("Failed to  sign up:", error);
      throw error.message;
    }
  }

  async forgotPassword(payload: any) {
    try {
      let url = `${this.baseURL}/forgot-password`;
      const response = await axios.post(url, payload);

      return response.data;
    } catch (error) {
      console.error("Failed to  get token:", error);
      throw error;
    }
  }

  async changePassword(payload: any) {
    try {
      let url = `${this.baseURL}/change-password`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (error) {
      console.error("Failed to  sign up:", error);
      throw error;
    }
  }

  // create an async function to send a notification to the user, endpoint = "notification"
  async sendNotification(payload: any) {
    try {
      let url = `${this.baseURL}/notification`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (error) {
      console.error("Failed to send notification:", error);
      throw error;
    }
  }

  async changeEmail(payload: any) {
    try {
      let url = `${this.baseURL}/change-email`;
      const response = await axios.post(url, payload);

      return response.data;
    } catch (error) {
      console.error("Failed to  get token:", error);
      throw error;
    }
  }

  async uploadContent(setObject: any, data: any) {
    const {
      file,
      user_id,
      title,
      type,
      visibility,
      approved,
      description,
      premium,
      showonhome,
    } = data;
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const formData = new FormData();
    formData.append("file", file);
    formData.append("user_id", user_id);
    formData.append("title", title);
    formData.append("type", type);
    formData.append("visibility", visibility);
    formData.append("approved", approved);
    formData.append("description", description);
    formData.append("premium", premium);
    formData.append("showonhome", showonhome);

    try {
      let url = `${this.baseURL}/contents`;
      const response = await axios.post(url, formData, config);
      await this.fetchData(null, setObject);
      return response.data;
    } catch (error: any) {
      console.error("Failed to create data:", error);
      throw error;
    }
  }

  async uploadPicture(data: any, type: string) {
    const { file, id } = data;
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const formData = new FormData();
    formData.append("image", file);
    formData.append("type", type);

    try {
      let url = `${this.baseURL}/pictures/${id}`;
      const response = await axios.post(url, formData, config);
      return response.data;
    } catch (error: any) {
      console.error("Failed to create data:", error);
      throw error;
    }
  }

  async makePayment(data: any, setObject: any) {
    const { file, user_id, subscription_id } = data;
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const formData = new FormData();
    formData.append("image", file);
    formData.append("user_id", user_id);
    formData.append("subscription_id", subscription_id);

    try {
      let url = `${this.baseURL}/${this.apiEndpoint}`;
      const response = await axios.post(url, formData, config);
      await this.fetchData(user_id, setObject);
      return response.data;
    } catch (error: any) {
      console.error("Failed to create data:", error);
      throw error;
    }
  }

  async addCarousel(data: any, setObject: any) {
    const { image, index, description, title } = data;
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const formData = new FormData();
    formData.append("image", image);
    formData.append("index", index);
    formData.append("description", description);
    formData.append("title", title);

    try {
      let url = `${this.baseURL}/${this.apiEndpoint}`;
      const response = await axios.post(url, formData, config);
      await this.fetchData(null, setObject);
      return response.data;
    } catch (error: any) {
      console.error("Failed to create data:", error);
      throw error;
    }
  }

  async editCarousel(id: string, data: any, setObject: any) {
    const { image, index, description, title } = data;
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const formData = new FormData();
    formData.append("image", image);
    formData.append("index", index);
    formData.append("description", description);
    formData.append("title", title);

    try {
      let url = `${this.baseURL}/${this.apiEndpoint}/${id}`;
      const response = await axios.put(url, formData, config);
      await this.fetchData(null, setObject);
      return response.data;
    } catch (error: any) {
      console.error("Failed to create data:", error);
      throw error;
    }
  }

  async verifyEmail(token: string) {
    let url = `${this.baseURL}/verify-email/${token}`;

    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Failed to verify email:", error);
      throw error;
    }
  }

  async sendVerificationEmail(email: string) {
    let url = `${this.baseURL}/send-verification-email`;
    try {
      const response = await axios.post(url, { email });
      return response.data;
    } catch (error) {
      console.error("Failed to send verification email:", error);
      throw error;
    }
  }

  static view_content = (content: any, auth: any, viewService: any) => {
    let uid = auth.isOrg ? auth.user.organisation_id : auth.user.uid;
    if (!auth.isOrg && content?.user_id !== uid) {
      // add a view
      viewService.createData({ content_id: content.content_id, user_id: uid });
    }
  };
}

export default API;
